/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 26/06/2023
 */
import React, { useState, useEffect } from "react";
import {
  Stack,
  LinearProgress,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material"
import PendingGroupsItem from "./PendingGroupsItem";
import api from "../../../../base/services/ResApi";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import Alerts from "../../../../base/errorHandeling/Alerts";
import SearchIcon from "@mui/icons-material/Search"

const PendingGroups = ({
  updateData,
  refreshKey = 0,
setUpdateData,
  setPendingCount,
  orgCode,
}) => {
  const [pendingData, setPendingData] = useState([]);
  const [filterData, setfilterData] = useState([])
  const [pendingLoading, setPendingLoading] = useState(true);

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [iserrorShow, setIserrorShow] = useState(false);
  const [isUnauhtError, setIsUnauhtError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  let pendConfig = {
    headers: {
      Action: "V_ALL_NON_APPR_GRP",
      "Page-Number": 1,
      "Page-Size": 5000,
      "Sort-Column": "grp_id",
      "Sort-Order": "asc",
      Filter: "F_ORG_CODE",
      Value: orgCode,
      "Is-Pagination": "true",
    },
  };

  useEffect(() => {
    setPendingLoading(true);
    orgCode &&
      api
        .get("/groups", pendConfig)
        .then((res) => {
          setPendingData(res.data?.dataList);
          setfilterData(res.data?.dataList)
          setPendingCount(res.data?.total);
          setPendingLoading(false);
          setErrorMessages([]);
          setIserror(false);
          setIsUnauhtError(false);
          setUpdateData(false)
        })
        .catch((error) => {
          console.log(error);
          setPendingLoading(false);
          setUpdateData(false)
          FetchErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow,
            setIsUnauhtError
          );
        });
  }, [updateData, isUnauhtError, orgCode, refreshKey]);

  useEffect(() => {
    if (iserror === true) {
      setTimeout(() => {
        setIserror(false);
        setErrorMessages([]);
      }, 10000);
    }
  }, [iserror]);

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false);
        setSuccessMessages([]);
      }, 3000);
    }
  }, [isSuccess]);

  const searchFilter = (e) => {
    const searchVal = e.target.value
    const results = pendingData.filter((grp) => {
      return grp.groupName.toLowerCase().includes(searchVal.toLowerCase())
    })
    setfilterData(results)
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "100%", maxWidth: 360, minHeight: 58, mb: 3 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Group"
          inputProps={{ "aria-label": "search role" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {pendingLoading ? (
        <LinearProgress />
      ) : (
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          {filterData?.map((d, i) => {
            return (
              <PendingGroupsItem
                key={d?.approveId}
                orgId={d?.orgId}
                orgCode={d?.orgCode}
                approveId={d?.approveId}
                groupName={d?.groupName}
                description={d?.description}
                serial={d?.serial}
                action={d?.action}
                updatedOn={d?.updatedOn}
                createdBy={d?.createdBy}
                createdTime={d?.createdTime}
                updatedBy={d?.updatedBy}
                updatedTime={d?.updatedTime}
                approvedBy={d?.approvedBy}
                approvedTime={d?.approvedTime}
                approvedStatus={d?.approvedStatus}
                setUpdateData={setUpdateData}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
};
export default PendingGroups;
